import { useState } from "react";
import axios from "../axios";
import { toast } from "sonner";

export const useGetArenaProfile = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const GetArenaProfile = async (isArena) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `/audiences/arena-profile?is_arena=${isArena}`
      );

      if (res.status === 201) {
        setLoading(false);
        setData(res?.data?.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };
  return { GetArenaProfile, loading, data };
};
